import { mapState } from 'vuex'

export default {
  props: {
    fieldRedirection: { type: String }
  },
  computed: {
    ...mapState({
      resource: state => state.kreaResource.resource
    })
  },
  mounted() {
    if (this.fieldRedirection && this.resource) this.$nextTick(this.redirectToField)
  },
  watch: {
    resource() {
      if (this.fieldRedirection) this.$nextTick(this.redirectToField)
    }
  },
  methods: {
    redirectToField() {
      const element = document.getElementById(this.fieldRedirection)
      const navbarOffset = 90
      const progressBarOffset = 90
      const elementPosition = element.getBoundingClientRect().top
      const offsetPosition = elementPosition + window.scrollY - (navbarOffset + progressBarOffset)

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      })
      element.classList.add('highlight')
      setTimeout(() => {
        element.classList.remove('highlight')
      }, 1500)
    }
  }
}
